import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { User } from 'app/@core/interfaces/common/users';
import { UserStore } from 'app/@core/stores/user.store';
import { DeviceDetectorModule, DeviceInfo } from 'ngx-device-detector';
import { NativeAppService } from 'app/@core/backend/common/services/native-app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-premium-trial-reminder',
  templateUrl: './premium-trial-reminder.component.html',
  styleUrls: ['./premium-trial-reminder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PremiumTrialReminderComponent implements OnInit {
  daysLeft: number;
  isUnlimitedTrialActive: boolean;
  isUnlimitedTrial: boolean;
  isFreePlan: boolean;
  isOnDemoOfferPlan:boolean;

  private readonly unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private userStore: UserStore, private nativeAppSerivce: NativeAppService, private router:Router, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.userStore
      .onUserStateChange()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((user: User) => {
        if (!user) return;

        this.isUnlimitedTrialActive = this.userStore.isUnlimitedTrialActive();
        this.isUnlimitedTrial = this.userStore.isUnlimitedTrial();
        this.daysLeft = this.userStore.daysLeftInProTrial();
        this.isFreePlan = this.userStore.isOnFreePlan() && !this.nativeAppSerivce.isFromApp();
        this.isOnDemoOfferPlan = this.userStore.isOnDemoOfferPlan();
        this.cdRef.detectChanges();

      });
  }


  onLinkClick() {
    this.router.navigateByUrl("/pages/CalorieFriend/manage-subscription");
  }
}
